import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class ThresholdClassificationsService {

  static getAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}threshold_classifications`).then((data) => {
        resolve({ thresholdClassifications: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default ThresholdClassificationsService;
